import { Injectable } from '@angular/core';

import { HttpService } from '../http/http.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class LocaService {
  private apiUrl = '/locas';
  private apiPlayUrl = '/play/locas';
  private apiSpringUrl = '/spring/locas';
  private apiLocashelfUrl = '/spring/locas/shelf';

  constructor(
    private http: HttpService) { }

  get(): Promise<any> {
    const url = environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl;
    return this.http.get(url);
  }

  post(
    locaCd: string,
    locaTx: string,
    locabarcodeTx: string,
    srclocaCd: string,
    typestockCd: string,
    typecoldCd: string,
    typeitemCd: string,
    locablockCd: string,
    locaabcId: number,
    arrivepriorityNr: number,
    shippriorityNr: number,
    notarriveFl: number,
    notshipFl: number,
    mixitemFl: number,
    mixlotFl: number,
    mixuselimitFl: number,
    memoTx: string,
    upduserId: number,
    updprogramCd: string
  ): Promise<any> {
    const url = environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl;
    const jsonInput = {
      locaCd: locaCd,
      locaTx: locaTx,
      locabarcodeTx: locabarcodeTx,
      srclocaCd: srclocaCd,
      typestockCd: typestockCd,
      typecoldCd: typecoldCd,
      typeitemCd: typeitemCd,
      locablockCd: locablockCd,
      locaabcId: locaabcId,
      arrivepriorityNr: arrivepriorityNr,
      shippriorityNr: shippriorityNr,
      notarriveFl: notarriveFl,
      notshipFl: notshipFl,
      mixitemFl: mixitemFl,
      mixlotFl: mixlotFl,
      mixuselimitFl: mixuselimitFl,
      memoTx: memoTx,
      upduserId: upduserId,
      updprogramCd: updprogramCd
    };

    return this.http.post(url, jsonInput);
  }

  put(
    locaId: number,
    locaCd: string,
    locaTx: string,
    locabarcodeTx: string,
    srclocaCd: string,
    typestockCd: string,
    typecoldCd: string,
    typeitemCd: string,
    locablockCd: string,
    locaabcId: number,
    arrivepriorityNr: number,
    shippriorityNr: number,
    notarriveFl: number,
    notshipFl: number,
    mixitemFl: number,
    mixlotFl: number,
    mixuselimitFl: number,
    memoTx: string,
    upduserId: number,
    updprogramCd: string
  ): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}/${locaId}`;
    const jsonInput = {
      locaCd: locaCd,
      locaTx: locaTx,
      locabarcodeTx: locabarcodeTx,
      srclocaCd: srclocaCd,
      typestockCd: typestockCd,
      typecoldCd: typecoldCd,
      typeitemCd: typeitemCd,
      locablockCd: locablockCd,
      locaabcId: locaabcId,
      arrivepriorityNr: arrivepriorityNr,
      shippriorityNr: shippriorityNr,
      notarriveFl: notarriveFl,
      notshipFl: notshipFl,
      mixitemFl: mixitemFl,
      mixlotFl: mixlotFl,
      mixuselimitFl: mixuselimitFl,
      memoTx: memoTx,
      upduserId: upduserId,
      updprogramCd: updprogramCd
    };
    return this.http.put(url, jsonInput);
  }

  postForDel(selectIds: number[]): Promise<any> {
    // Play API
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}/delete`;
    const jsonInput = {locaIdList: selectIds};
    return this.http.post(url, jsonInput);
  }

  getStockExistsError(trnId: number): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiPlayUrl}/getStockExistsError/${trnId}`;
    const jsonInput = {trnId: trnId}
    return this.http.get(url);
  }

  upload(file: File): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiUrl}/excelupload`;
    const formData: FormData = new FormData();
    formData.append('uploadFile', file, file.name);
    const header = {
      'Accept': 'application/json',
      'x-api-key': localStorage.getItem('apiKey'),
      'x-session-key': (JSON.parse(sessionStorage.getItem('loginResult')))['sessionKey'],
      'x-csrf-token': (JSON.parse(sessionStorage.getItem('loginResult')))['csrfToken']
    };
    return this.http.post(url, formData, header);
  }

  postLocashelf(
    whCd: string,
    floorCd: string,
    areaCd: string,
    lineCd: string,
    shelfCd: string,
    shelfcaseId: number,
    ownerId: number,
    typestockCd: string,
    typecoldCd: string,
    locablockCd: string,
    locaabcId: number,
    notarriveFl: number,
    notshipFl: number,
    updprogramCd: string
  ): Promise<any> {
    const url = environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiLocashelfUrl;
    const jsonInput = {
      whCd: whCd,
      floorCd: floorCd,
      areaCd: areaCd,
      lineCd: lineCd,
      shelfCd: shelfCd,
      shelfcaseId: shelfcaseId,
      ownerId: ownerId,
      typestockCd: typestockCd,
      typecoldCd: typecoldCd,
      locablockCd: locablockCd,
      locaabcId: locaabcId,
      notarriveFl: notarriveFl,
      notshipFl: notshipFl,
      updprogramCd: updprogramCd
    };

    return this.http.post(url, jsonInput);
  }

  putLocashelf(
    locashelfCd: string,
    typestockCd: string,
    typecoldCd: string,
    locablockCd: string,
    locaabcId: number,
    notarriveFl: number,
    notshipFl: number,
    updprogramCd: string
  ): Promise<any> {
    const url = environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiLocashelfUrl + "/" + locashelfCd;
    const jsonInput = {
      typestockCd: typestockCd,
      typecoldCd: typecoldCd,
      locablockCd: locablockCd,
      locaabcId: locaabcId,
      notarriveFl: notarriveFl,
      notshipFl: notshipFl,
      updprogramCd: updprogramCd
    };

    return this.http.put(url, jsonInput);
  }

}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/service/loca/loca.service.ts